<pre>{{ contents }}</pre>